import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from 'components/common/PageHeader';

const ProcessTimeLineFrete = ({
  abertura,
  prontidao,
  coleta,
  embarqueInicial,
  dadosProcesso,
  dadosTransbordo,
  descarga,
  dta
}) => {
  return (
    <>
      <PageHeader title={``} titleTag="h5" className="mb-4">
        <div>
          <div id="process">
            <ul id="stepButtons" className="process-row nav nav-tabs">
              {abertura.DataAbertura !== null ? (
                <>
                  {abertura.DataAbertura !== null &&
                  abertura.DataAbertura !== '00/00/0000' ? (
                    <li className="process-step active">
                      <button
                        type="button"
                        className="btn btn-circle btn-default"
                      >
                        <i className="fa fa-info" height="90" />
                      </button>
                      <p>
                        ABERTURA DE PROCESSO
                        <small>{abertura.DataAbertura}</small>
                      </p>
                    </li>
                  ) : (
                    <li className="process-step">
                      <button
                        type="button"
                        className="btn btn-circle btn-default"
                      >
                        <i className="fa fa-info" />
                      </button>
                      <p>ABERTURA DE PROCESSO</p>
                    </li>
                  )}
                </>
              ) : (
                <></>
              )}
              {prontidao.PrevProntidao !== null ? (
                <>
                  {prontidao.Prontidao !== null &&
                  prontidao.Prontidao !== '00/00/0000' ? (
                    <li className="process-step active">
                      <button
                        type="button"
                        className="btn btn-circle btn-default"
                      >
                        <i className="fa fa-info" height="90" />
                      </button>
                      <p>
                        PRONTIDÃO CARGA<small>{prontidao.Prontidao}</small>
                      </p>
                    </li>
                  ) : prontidao.PrevProntidao !== null &&
                    prontidao.PrevProntidao !== '00/00/0000' ? (
                    <li className="process-step">
                      <button
                        type="button"
                        className="btn btn-circle btn-default"
                      >
                        <i className="fa fa-info" height="90" />
                      </button>
                      <p>
                        PRONTIDÃO CARGA
                        <small>Prev. {prontidao.PrevProntidao}</small>
                      </p>
                    </li>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
              {coleta.DataColeta !== null ? (
                <>
                  {coleta.DataColeta !== null &&
                  coleta.DataColeta !== '00/00/0000' ? (
                    <li className="process-step active">
                      <button
                        type="button"
                        className="btn btn-circle btn-default"
                      >
                        <i className="fa fa-info" height="90" />
                      </button>
                      <p>
                        COLETA NA ORIGEM<small>{coleta.DataColeta}</small>
                      </p>
                    </li>
                  ) : (
                    <></>
                    // <li className="process-step">
                    //   <button
                    //     type="button"
                    //     className="btn btn-circle btn-default"
                    //     data-toggle="tab"
                    //     href="#step1"
                    //   >
                    //     <i className="fa fa-info fa-3x"></i>
                    //   </button>
                    //   <p>
                    //     COLETA NA ORIGEM<small></small>
                    //   </p>
                    // </li>
                  )}
                </>
              ) : (
                <></>
                // <li className="process-step">
                //   <button
                //     type="button"
                //     className="btn btn-circle btn-default"
                //     data-toggle="tab"
                //     href="#step1"
                //   >
                //     <i className="fa fa-info fa-3x"></i>
                //   </button>
                //   <p>
                //     COLETA NA ORIGEM<small></small>
                //   </p>
                // </li>
              )}

              {embarqueInicial.DataInicial !== null ? (
                <>
                  {embarqueInicial.DataInicial !== null &&
                  embarqueInicial.DataInicial !== '00/00/0000' ? (
                    <>
                      <li className="process-step active">
                        <button
                          type="button"
                          className="btn btn-circle btn-default"
                        >
                          <i className="fa fa-calendar-check" height="90" />
                        </button>
                        <p>
                          EMBARQUE INICIAL<small>{embarqueInicial.Origem}</small>
                          <small>{embarqueInicial.DataInicial}</small>
                        </p>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : embarqueInicial.PrevDataInicial !== null &&
                embarqueInicial.PrevDataInicial !== '00/00/0000' ? (
                <>
                  <li className="process-step">
                    <button
                      type="button"
                      className="btn btn-circle btn-default"
                    >
                      <i className="fa fa-calendar-check" height="90" />
                    </button>
                    <p>
                      EMBARQUE INICIAL<small>{embarqueInicial.Origem}</small>
                      <small>Prev. {embarqueInicial.PrevDataInicial}</small>
                    </p>
                  </li>
                </>
              ) : (
                (<>
                  <li className="process-step">
                    <button
                      type="button"
                      className="btn btn-circle btn-default"
                      data-toggle="tab"
                      href="#step1"
                    >
                      <i className="fa fa-calendar-check fa-3x"></i>
                    </button>
                    <p>
                      EMBARQUE INICIAL<small></small>
                    </p>
                  </li>
                </>)(<></>)
              )}

              {/* {embarqueInicial.map(coleta => {
                return (
                  <>
                    {row.DataInicial !== null &&
                      row.DataInicial !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                          >
                            <i className="fa fa-calendar-check" height="90" />
                          </button>
                          <p>
                            EMBARQUE INICIAL<small>{row.Origem}</small>
                            <small>{row.DataInicial}</small>
                          </p>
                        </li>
                      </>
                    ) : row.PrevDataInicial !== null &&
                      row.PrevDataInicial !== '00/00/0000' ? (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                          >
                            <i className="fa fa-calendar-check" height="90" />
                          </button>
                          <p>
                            EMBARQUE INICIAL<small>{row.Origem}</small>
                            <small>Prev. {row.PrevDataInicial}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step1"
                          >
                            <i className="fa fa-calendar-check fa-3x"></i>
                          </button>
                          <p>
                            EMBARQUE INICIAL<small></small>
                          </p>
                        </li>
                      </>
                    )}
                  </>
                )
              })} */}

              {/* {dadosTransbordo.map((transbordo, index) => {
                return (
                  <>
                    {transbordo.DataInicial !== null ?
                      <>
                        <>
                          <li className="process-step active" key={index}>
                            <button
                              type="button"
                              className="btn btn-circle btn-default"
                              data-toggle="tab"
                              href="#step3"
                            >
                              <i className="fa fa-truck-plane fa-3x"></i>
                            </button>
                            <p>
                              TRANSBORDO<small>{transbordo.Origem}</small>
                              <small>{transbordo.DataInicial}</small>
                            </p>
                          </li>
                        </>
                      </> :
                      transbordo.PrevDataInicial !== null ?
                        <>
                          <li className="process-step" key={index}>
                            <button
                              type="button"
                              className="btn btn-circle btn-default"
                              data-toggle="tab"
                              href="#step3"
                            >
                              <i className="fa fa-truck-plane fa-3x"></i>
                            </button>
                            <p>
                              TRANSBORDO<small>{transbordo.Origem}</small>
                              <small>Prev. {transbordo.PrevDataInicial}</small>
                            </p>
                          </li>
                        </>
                        :
                        <></>
                    }
                  </>

                );
              })} */}

              {/* {dadosTransbordo.length > 0 ? (
                <></>
              ) : (
                <>
                  <li className="process-step">
                    <button
                      type="button"
                      className="btn btn-circle btn-default"
                      data-toggle="tab"
                      href="#step3"
                    >
                      <i className="fa fa-truck-plane fa-3x"></i>
                    </button>
                    <p>
                      TRANSBORDO<small></small>
                    </p>
                  </li>
                </>
              )} */}
              {/* {descarga.map(row => {
                return (
                  <>
                    {row.DataDescarga !== null &&
                      row.DataDescarga !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                          >
                            <i className="fa fa-calendar-day" height="90" />
                          </button>
                          <p>
                            CHEGADA<small>{row.Origem}</small>
                            <small>{row.DataDescarga}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <></>
                      // <>
                      //   <li className="process-step">
                      //     <button
                      //       type="button"
                      //       className="btn btn-circle btn-default"
                      //       data-toggle="tab"
                      //       href="#step1"
                      //     >
                      //       <i className="fa fa-calendar-day fa-3x"></i>
                      //     </button>
                      //     <p>
                      //       DESCARGA<small></small>
                      //     </p>
                      //   </li>
                      // </>
                    )}
                  </>
                )
              })}               */}
              {/* {dta.length > 0 ? (
                dta.map((row, index) => {
                  return (
                    <React.Fragment key={index}>
                      {row.DataDescarga !== null && row.DataDescarga !== '00/00/0000' ? (
                        <li className="process-step active">
                          <button type="button" className="btn btn-circle btn-default">
                            <i className="fa fa-calendar-check" height="90" />
                          </button>
                          <p>
                            EMBARQUE DTA<small>{row.Origem}</small>
                            <small>{row.DataDescarga}</small>
                          </p>
                        </li>
                      ) : (
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step1"
                          >
                            <i className="fa fa-calendar-check fa-3x"></i>
                          </button>
                          <p>
                            EMBARQUE DTA<small></small>
                          </p>
                        </li>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <></>
                // <li className="process-step">
                //   <button
                //     type="button"
                //     className="btn btn-circle btn-default"
                //     data-toggle="tab"
                //     href="#step1"
                //   >
                //     <i className="fa fa-calendar-check fa-3x"></i>
                //   </button>
                //   <p>
                //     EMBARQUE DTA<small></small>
                //   </p>
                // </li>
              )} */}
            </ul>
          </div>
        </div>
      </PageHeader>
    </>
  );
};

ProcessTimeLineFrete.propTypes = {
  dadosProcesso: PropTypes.object,
  dadosTransbordo: PropTypes.object
};

export default ProcessTimeLineFrete;
